module.exports = "<router-outlet>\n    <app-spinner></app-spinner>\n    \n</router-outlet>"